<template>
  <modal name="moveToCategory"
    transition="nice-modal-fade"
    :width="600"
    :height="236"
    :pivotY="0.3"
    @before-open="beforeOpen"
    :classes="['user-categories']"
    ref="modal"
  >
    <div class="container" @keydown.stop @mousedown.stop="onClickModalArea()">
      <div class="header">
        <span>移动</span>
        <div class="close-btn" @click="clickToClose()">
          <i class="icon-popup-close"></i>
        </div>
      </div>
      <div class="content" v-if="isMainView">
        <span>将素材移动到自定义分类</span>
        <div class="drop-down-wrapper">
          <DropDownMenu
            v-if="cateOptions && cateOptions.length"
            :options="cateOptions"
            :selectedIndex="selectedCateIndex"
            :all="'默认文件夹'"
            :myStyle="{
              height: '38px',
              width: '342px'
            }"
            @clickItem="changeSelectedIndex"
            ref="dropdown"
          ></DropDownMenu>
        </div>
      </div>
      <div class="content" v-else>
        您还没有自定义分类，是否去新建分类？
      </div>
      <div class="footer">
        <div class="btn cancel" @click="clickToClose()"><span>取消</span></div>
        <div class="btn confirm" @click="onConfirm(selectedCateIndex)"><span>确定</span></div>
      </div>
    </div>
  </modal>
</template>

<script>
import DropDownMenu from '../controls/menu';

export default {
  components: {
    DropDownMenu
  },
  data () {
    return {
      modalParams: {
        requestingId: '',
        list: []
      },
      cateOptions: [],
      selectedCateIndex: -1
    }
  },
  computed: {
    isMainView () {
      return this.cateOptions && this.cateOptions.length
    }
  },
  created () {

  },
  methods: {
    onConfirm (index) {
      if (this.isMainView) {
        this.selectCategory(index);
      } else {
        this.clickToClose();
        this.$modal.show('setUserCategories', {
          requestingId: this.modalParams.requestingId,
          list: this.cateOptions
        });
      }
    },
    clickToClose () {
      this.$modal.hide(this.$refs.modal.name);
    },
    beforeOpen ({params} = {}) {
      this.modalParams = params;
      this.cateOptions = params.list;
      this.selectedCateIndex = params.index || -1;
    },
    changeSelectedIndex (index) {
      this.selectedCateIndex = index;
    },
    selectCategory (index) {
      this.selectedCateIndex = index;
      let cate = this.cateOptions[index] || {};
      return this.$http.post('/api/user/material/addMaterialCategory', {
        materialType: this.modalParams.requestingId,
        materialId: this.modalParams.materialId,
        categoryId: cate.id || '',
        ourself: 1
      }).then(res => {
        if (res.data.code === 200) {
          this.$bus.emit('moveToCategory.done', index);
        }
      })
    },
    onClickModalArea () {
      this.$refs.dropdown && (this.$refs.dropdown.focus = false);
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  box-shadow: none;
  position: relative;
  width: 100%;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;
  margin: auto;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 600px;
	height: 40px;
	background-color: #d9ddea;
  border-radius: 4px 4px 0px 0px;
  padding-left: 1.2em;
  padding-right: 1.2em;
  color: #474261;
}
.content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  color: #474261;
  background-color: #ffffff;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 40px;
  padding-bottom: 40px;
  background-color: #ffffff;

  >div:nth-of-type(1) {
    margin-right: 25px;
  }
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
	height: 40px;
	background-color: #5778fb;
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  &:hover {
    background-color: #5656e8;
  }

  &.cancel {
    background-color: #eaeaf6;
    color: #474261;
    &:hover {
      background-color:#dfdfe7;
    }
  }
}
.close-btn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  &>i {
    height: 16px;
    width: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/modals/moveToCategory.vue